<ng-container *ngIf="product$ | async as product">
  <div class="product__features" data-cy="specs-box">
    <ng-container *ngFor="let classification of product.classifications">
      <ng-container *ngFor="let feature of classification.features">
        <ng-container *ngIf="!isNumberFeatureAndHasEmptyValue(feature)">
          <div class="product__feature" [attr.data-cy]="'feature-code-' + feature.code">
            <div class="product__feature-title">
              {{ feature.name }}
            </div>
            <div class="product__feature-values">
              <span [attr.data-cy]="'feature-value'">{{ showFeatureValues(feature) }}</span>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>
  </div>
</ng-container>
